import React from "react";
import Header_m from "../header/Header";
import Footer_m from "../footer/Footer";
import AboutMessage from "../About/AboutUs";

const About =() =>{
    return(
        <div>
            {/* <Header_m></Header_m> */}

            <div className="container">

                <AboutMessage></AboutMessage>
            </div>

            <Footer_m></Footer_m>
        </div>
    )
}
export default About;
